export default __webpack_public_path__ + "static/media/chip.344f3b03.svg";